<template>
  <div>
    <modal
      name="editCampoAdicional"
      height="auto"
      width="1300"
      :scrollable="true"
      :clickToClose="false"
    >
      <CampoAdicionalOpcoes :campoEditado="campoEditado" />
      <CampoAdicionalSql :campoEditado="campoEditado" :entidade="entidade.chave" ref="campoAdicionalSql" />
      <CloseModal :close="close" />

      <div class="modalbox">
        <div class="modalbox-content">
          <div class="modal-header-info">
            <div class="header-title">
              <span class="header-entidade">{{ entidade.titulo }}</span>
              <fa-icon icon="chevron-right" class="header-separator" />
              <span class="header-contexto">{{ contexto.titulo }}</span>
            </div>
            <div class="header-desc" v-if="contexto.descricao">
              {{ contexto.descricao }}
            </div>
          </div>

          <div
            v-if="!entidade.ordem_por_vinculo && campos.length > 0"
            class="hint-bar"
          >
            <fa-icon icon="info-circle" class="hint-icon" />
            Segure e arraste pelo ícone
            <fa-icon icon="grip-vertical" class="hint-grip" /> para reordenar os
            campos.
          </div>

          <div
            v-if="entidade.ordem_por_vinculo"
            class="hint-bar hint-bar--info"
          >
            <fa-icon icon="info-circle" class="hint-icon" />
            Para vincular o campo adicional a
            <strong>Tipos ou Etapas de Ticket,</strong> você deve configurá-los
            diretamente no módulo de
            <strong>Cadastros → SAC → Tipos Tickets e Etapas</strong> e edite o
            tipo/etapa desejado.
          </div>

          <div v-if="campos.length === 0" class="empty-state">
            <div class="empty-icon">
              <fa-icon icon="cubes" />
            </div>
            <div class="empty-text">Nenhum campo adicional criado</div>
            <div class="empty-desc">
              Clique no botao abaixo para adicionar o primeiro campo.
            </div>
          </div>

          <draggable
            v-model="campos"
            handle=".drag-handle"
            @end="onDragEnd"
            :animation="200"
            :disabled="entidade.ordem_por_vinculo"
          >
            <div
              v-for="(campo, indice) in campos"
              :key="campo._key || indice"
              class="campo-card"
              :class="{ 'campo-card--invalid': !isCampoValido(campo) }"
            >
              <div class="campo-card-header">
                <div class="drag-handle" v-show="!entidade.ordem_por_vinculo">
                  <fa-icon icon="grip-vertical" />
                </div>
                <span class="campo-ordem-badge">#{{ indice + 1 }}</span>
                <span class="campo-label-preview" v-if="campo.label">{{
                  campo.label
                }}</span>
                <span
                  class="campo-label-preview campo-label-preview--empty"
                  v-else
                  >Sem titulo</span
                >
                <button
                  type="button"
                  class="btn-remove"
                  @click="onRemoveCampo(indice)"
                  title="Remover campo"
                >
                  <fa-icon icon="trash-alt" />
                </button>
              </div>

              <div class="campo-card-body">
                <div class="row form-group">
                  <div class="col-md-3">
                    <label class="field-label">Titulo</label>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="campo.label"
                      placeholder="Nome do campo"
                      :class="{
                        'is-invalid':
                          !campo.label || campo.label.trim().length === 0,
                      }"
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="field-label">Chave</label>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="campo.indice"
                      placeholder="identificador"
                      :class="{
                        'is-invalid':
                          !campo.indice || campo.indice.trim().length === 0,
                      }"
                      @input="
                        (event) => {
                          campo.indice = event.target.value.replace(/ /g, '_');
                        }
                      "
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="field-label">Formato</label>
                    <div>
                      <select
                        class="form-control form-control-sm"
                        :class="{
                          'is-invalid':
                            !campo.formato || campo.formato.trim().length === 0,
                        }"
                        v-model="campo.formato"
                        @change="handleChangeFormatoField(campo)"
                      >
                        <option value="" disabled>Selecione</option>
                        <option
                          v-for="formato in formatosDisponiveis"
                          :key="formato.key"
                          :value="formato.key"
                        >
                          {{ formato.label }}
                        </option>
                      </select>
                      <button
                        v-if="
                          checkCampoAtivo(formatos, campo.formato, 'options')
                        "
                        class="btn-opcoes"
                        @click="openModalOpcoes(campo)"
                      >
                        <fa-icon icon="list-alt" /> Opcoes
                      </button>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <label class="field-label">Tipo opcao</label>
                    <select
                      class="form-control form-control-sm"
                      :disabled="!isMultiOpcoes(campo.formato)"
                      v-model="campo.usa_sql"
                    >
                      <option value="0">Texto</option>
                      <option value="1">Query</option>
                    </select>
                  </div>
                  <div class="col-md-1">
                    <label class="field-label">Tamanho</label>
                    <input
                      :disabled="
                        !checkCampoAtivo(formatos, campo.formato, 'size')
                      "
                      class="form-control form-control-sm"
                      type="number"
                      v-model="campo.tamanho"
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Valor padrao</label>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      v-model="campo.valor_padrao"
                      placeholder="Opcional"
                    />
                  </div>
                </div>

                <div
                  v-if="entidade.chave !== 'ticket'"
                  class="row campo-footer-row"
                >
                  <div class="col-auto">
                    <div class="toggle-row">
                      <label
                        class="toggle-item"
                        :class="{ active: Boolean(campo.obrigatorio) }"
                      >
                        <input
                          type="checkbox"
                          :checked="Boolean(campo.obrigatorio)"
                          @change="campo.obrigatorio = !campo.obrigatorio"
                        />
                        Obrigatorio
                      </label>
                    </div>
                  </div>
                  <div class="col">
                    <label class="field-label">Exibir nos sistemas</label>
                    <div class="sistemas-chips">
                      <label
                        v-for="sis in sistemasDisponiveis"
                        :key="sis.chave"
                        class="sistema-chip"
                        :class="{
                          active:
                            campo.sistemas &&
                            campo.sistemas.includes(sis.chave),
                        }"
                      >
                        <input
                          type="checkbox"
                          :checked="
                            campo.sistemas && campo.sistemas.includes(sis.chave)
                          "
                          @change="toggleSistema(campo, sis.chave)"
                        />
                        {{ sis.label }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </div>

      <div class="modal-footer-bar">
        <CButton color="success" size="sm" @click="onAdd">
          <fa-icon icon="plus" /> Incluir campo
        </CButton>
        <div class="footer-spacer"></div>
        <CButton variant="outline" color="secondary" @click="close">
          Cancelar
        </CButton>
        <CButton color="primary" @click="handleSubmit"> Salvar </CButton>
      </div>
    </modal>
  </div>
</template>

<script>
import CloseModal from "../../../components/CloseModal";
import CampoAdicionalOpcoes from "./CampoAdicionalOpcoes.vue";
import CampoAdicionalSql from "./CampoAdicionalSql.vue";
import draggable from "vuedraggable";
import _find from "lodash/find";

let keyCounter = 0;

const novoCampo = (ordem) => ({
  _key: `new_${++keyCounter}`,
  label: "",
  indice: "",
  formato: "",
  banco_opcao: "LOCAL",
  tamanho: "",
  obrigatorio: 0,
  valor_padrao: "",
  ordem: ordem,
  usa_sql: 0,
  sistemas: [],
  campo_adicional_opcoes: [],
});

export default {
  name: "Edit",
  components: {
    CloseModal,
    CampoAdicionalOpcoes,
    CampoAdicionalSql,
    draggable,
  },
  data() {
    return {
      campoEditado: {},
    };
  },
  props: [
    "close",
    "entidade",
    "contexto",
    "campos",
    "formatos",
    "sistemas",
    "onSubmit",
  ],
  computed: {
    sistemasDisponiveis() {
      const disponiveis = this.contexto.sistemas_disponiveis;
      if (!disponiveis || disponiveis.length === 0) {
        return this.sistemas;
      }
      return this.sistemas.filter((sis) => disponiveis.includes(sis.chave));
    },
    // Alguns formatos (ex.: Anexo) so fazem sentido pra determinadas entidades
    // (config `restrito_a.entidade`, back-end). Filtra aqui pra nao oferecer no
    // select um tipo que a entidade atual nao suporta - sem hardcode de nomes de
    // formato aqui, quem decide e o config do back-end.
    formatosDisponiveis() {
      return this.formatos.filter((formato) => {
        const entidadesRestritas = formato.restrito_a && formato.restrito_a.entidade;
        if (!entidadesRestritas) {
          return true;
        }
        const lista = Array.isArray(entidadesRestritas) ? entidadesRestritas : [entidadesRestritas];
        return lista.includes(this.entidade.chave);
      });
    },
  },
  methods: {
    handleSubmit() {
      const erros = this.validarCampos();
      if (erros.length > 0) {
        this.$swal({
          title: "Corrija os campos antes de salvar",
          html:
            '<ul style="text-align:left;margin:0;padding-left:18px">' +
            erros.map((e) => `<li>${e}</li>`).join("") +
            "</ul>",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }
      const camposComOrdem = this.campos.map((campo, index) => ({
        ...campo,
        ordem: !this.entidade.ordem_por_vinculo ? index + 1 : campo.ordem,
      }));
      this.onSubmit(camposComOrdem);
    },
    validarCampos() {
      const formatosComOpcoes = ["select", "checkbox", "multiselect", "radio"];
      const erros = [];

      this.campos.forEach((campo) => {
        const nome =
          campo.label && campo.label.trim()
            ? `<strong>${campo.label.trim()}</strong>`
            : "<strong>Campo sem título</strong>";

        if (!campo.label || !campo.label.trim()) {
          erros.push(`${nome}: título é obrigatório`);
        }
        if (!campo.indice || !campo.indice.trim()) {
          erros.push(`${nome}: chave é obrigatória`);
        }
        if (!campo.formato || !campo.formato.trim()) {
          erros.push(`${nome}: formato é obrigatório`);
        }

        if (campo.formato && formatosComOpcoes.includes(campo.formato)) {
          if (campo.usa_sql == 1) {
            if (!campo.query || !campo.query.trim()) {
              erros.push(`${nome}: a query é obrigatória para este formato`);
            }
          } else {
            const opcoes = campo.campo_adicional_opcoes || [];
            let temOpcaoValida = false;

            opcoes.forEach((opcao, i) => {
              const temChave = opcao.chave && opcao.chave.trim().length > 0;
              const temValor = opcao.valor && opcao.valor.trim().length > 0;
              if (temChave && temValor) {
                temOpcaoValida = true;
              } else if (temChave && !temValor) {
                erros.push(
                  `${nome}: opção ${
                    i + 1
                  } — chave preenchida mas valor está vazio`,
                );
              } else if (!temChave && temValor) {
                erros.push(
                  `${nome}: opção ${
                    i + 1
                  } — valor preenchido mas chave está vazia`,
                );
              }
            });

            if (!temOpcaoValida) {
              erros.push(
                `${nome}: deve ter pelo menos uma opção com chave e valor preenchidos`,
              );
            }
          }
        }
      });

      return erros;
    },
    checkCampoAtivo(configFormatos, formatoSelecionado, propriedade) {
      let propriedadesFormato = _find(configFormatos, {
        key: formatoSelecionado,
      });
      return propriedadesFormato ? propriedadesFormato[propriedade] : false;
    },
    onAdd() {
      const proximaOrdem = this.campos.length + 1;
      this.campos.push(novoCampo(proximaOrdem));
    },
    onRemoveCampo(indice) {
      this.campos.splice(indice, 1);
    },
    onDragEnd() {
      // Atualizar ordem apos drag
      this.campos.forEach((campo, index) => {
        campo.ordem = index + 1;
      });
    },
    isCampoValido(campo) {
      return (
        campo.label &&
        campo.label.trim().length > 0 &&
        campo.indice &&
        campo.indice.trim().length > 0 &&
        campo.formato &&
        campo.formato.trim().length > 0
      );
    },
    isMultiOpcoes(formato) {
      return ["select", "checkbox", "multiselect", "radio"].includes(formato);
    },
    toggleSistema(campo, sistema) {
      if (!campo.sistemas) {
        this.$set(campo, "sistemas", []);
      }
      const index = campo.sistemas.indexOf(sistema);
      if (index > -1) {
        campo.sistemas.splice(index, 1);
      } else {
        campo.sistemas.push(sistema);
      }
    },
    openModalOpcoes(campo) {
      this.campoEditado = campo;
      if (!campo.campo_adicional_opcoes) {
        this.$set(campo, "campo_adicional_opcoes", []);
      }

      if (campo.usa_sql == 1) {
        this.$modal.show("campoAdicionalSql");
      } else {
        this.$modal.show("campoAdicionalOpcoes");
      }
    },
    handleChangeFormatoField(campo) {
      campo.tamanho = null;
      campo.campo_adicional_opcoes = [];
    },
  },
};
</script>

<style scoped>
.modal-header-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
}

.header-entidade {
  font-weight: 600;
  color: #3a3e81;
}

.header-separator {
  font-size: 10px;
  color: #98a2b3;
}

.header-contexto {
  font-weight: 500;
  color: #344054;
}

.header-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 4px;
}

/* Hint bar */
.hint-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #667085;
  background: #f9fafb;
  border: 1px solid #e4e7eb;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 12px;
}

.hint-bar--info {
  background: #eff8ff;
  border-color: #b2ddff;
  color: #175cd3;
}

.hint-icon {
  font-size: 13px;
  flex-shrink: 0;
}

.hint-grip {
  font-size: 11px;
  color: #98a2b3;
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: #f2f2f8;
  color: #3a3e81;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}

.empty-text {
  font-weight: 600;
  font-size: 15px;
  color: #1d2939;
}

.empty-desc {
  font-size: 13px;
  color: #667085;
  margin-top: 4px;
}

/* Campo card */
.campo-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  margin-bottom: 10px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.campo-card:hover {
  border-color: #d0d5dd;
}

.campo-card--invalid {
  border-color: #fda29b;
}

.campo-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 10px 10px 0 0;
}

.drag-handle {
  cursor: grab;
  color: #98a2b3;
  padding: 2px 4px;
  font-size: 14px;
}

.drag-handle:active {
  cursor: grabbing;
}

.campo-ordem-badge {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  background: #e9ecef;
  padding: 1px 6px;
  border-radius: 4px;
}

.campo-label-preview {
  font-weight: 500;
  font-size: 13px;
  color: #344054;
  flex: 1;
}

.campo-label-preview--empty {
  color: #98a2b3;
  font-style: italic;
}

.btn-remove {
  background: none;
  border: none;
  color: #98a2b3;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.15s;
  font-size: 13px;
}

.btn-remove:hover {
  color: #d92d20;
  background: #fef3f2;
}

.campo-card-body {
  padding: 12px 14px;
}

.campo-card-body .form-group {
  margin-bottom: 8px;
}

/* Field labels */
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

/* Botao opcoes */
.btn-opcoes {
  background: none;
  border: 1px solid #dddce9;
  color: #3a3e81;
  font-size: 11px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 4px;
  transition: all 0.15s;
}

.btn-opcoes:hover {
  background: #f2f2f8;
}

/* Footer row */
.campo-footer-row {
  align-items: center;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #f2f4f7;
}

/* Toggle */
.toggle-row {
  display: flex;
  gap: 8px;
}

.toggle-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #e4e7eb;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #667085;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 0;
}

.toggle-item input[type="checkbox"] {
  accent-color: #3a3e81;
}

.toggle-item.active {
  border-color: #3a3e81;
  background: #f2f2f8;
  color: #3a3e81;
}

/* Sistemas chips */
.sistemas-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.sistema-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border: 1px solid #e4e7eb;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: #667085;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 0;
}

.sistema-chip input[type="checkbox"] {
  display: none;
}

.sistema-chip.active {
  border-color: #3a3e81;
  background: #eceaf3;
  color: #3a3e81;
}

.sistema-chip:hover {
  border-color: #b0bec5;
}

/* Modal footer */
.modal-footer-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
}

.footer-spacer {
  flex: 1;
}

/* Remove number spinners */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
